import React, { Component } from 'react';
import FakeData from '.././fake-data';
import ReactDOM from 'react-dom';
import { Helmet } from "react-helmet";
import { Link, Redirect, Prompt } from 'react-router-dom';
import './Search.css';

import { ChangePictureIcon, LiveGames, PostItem, EmptyState, LoadingState, GlobalTMFeeds, GlobalTMForm, LeagueSplitView, ConfirmModal, ItemPicker, Modal, ComboBox, PhotoAddModal, TagView, MomentPickerModal, EditGameModal, PublicityPicker, MediaItem, InfiniteScrollView, FilePostViewer } from '.././components/Common';
import { EventViewCreateForm1, EventViewSplitPane, EventGroupChatCreate, LocationPicker } from '.././components/Event';
import Avatar from '.././components/Avatar';
import GroupEvents, { EventCalenderView } from '.././components/GroupEvents';
import GroupMembers from '.././components/GroupMembers';
import RichTextEditor from '.././components/RichTextEditor';
import Photos from '.././components/Photos';
import Videos from '.././components/Videos';
import InternalNoticeCenter from '.././components/InternalNoticeCenter';
import { CreateNormalEvent, WeatherWidget } from './Home';
import { EvtFilterCal } from './Events';
import { RichTextInputField } from './Test';
import { EventKnowledgeCard } from './Event';
import Games, { UpcomingGameList } from '.././components/Games';

const Trojan = window.Trojan;
const Croppie = window.Croppie;
const $ = window.$;
const jQuery = window.jQuery;
const { google } = window;

export default class Search extends Component {
    constructor(props) {
        super(props);
        this.state = {
            filter: "All",
            activeItem: null,
            filters: [
                "All",
                "Posts",
                "People",
                "Media",
                "Games",
                "Clubs",
                "Teams",
                "Institutions",
                "Tournaments",
                "Groups",
                "Events"
            ],
            aFilter: {
                date: {
                    start: "",
                    end: ""
                },
                all: "",
                exact: "",
                none: "",
                any: ""
            },
            results: {
                search_data: {
                    query: "",
                    config: {
                        ver: "1.0.0"
                    },
                    queries: []
                },
                All: [],
                Posts: [],
                People: [],
                Media: [],
                Games: [],
                Clubs: [],
                Teams: [],
                Institutions: [],
                Tournaments: [],
                Groups: [],
                Events: []
            },
            isLoading: false,
            searches: [],
            offset: 0,
            isTyping: false,
            isSuggested: false,
            isSetting: false,
            obj: null
        }
    }

    componentDidMount() {
        var params = FakeData.getQueries(this.props.location.search);
        const { filter, filters, results } = this.state;
        FakeData.mountState("search", true)
        this.getSearches()
        if (params.q) {
            const _that = this;
            results.search_data.query = params.q;
            this.setState({ results });
            setTimeout(() => {
                _that.search()
            }, 150);
        }

    }

    getSearches = () => {
        ///getSearches.php?auth0
        //this.setState({ isLoading: true });
        const _that = this;
        const dataTo = {
            user: {
                id: FakeData.getData("yoo").id,
                type: "F"
            }
        }

        //console.log(dataTo);
        FakeData.post("/getSearches.php?auth0", dataTo, {
            success(res) {
                if (!FakeData.isMounted("search")) {
                    return
                }
                _that.setState({ searches: res });
                setTimeout(() => {
                    _that.getSearches()
                }, 2500)
            },
            error(err) {
                if (!FakeData.isMounted("search")) {
                    return
                }
                setTimeout(() => {
                    _that.getSearches()
                }, 5000)
            }
        })
    }

    search = () => {
        const { search_data } = this.state.results;
        const { aFilter } = this.state;
        if (search_data.query === "") {
            return;
        }

        this.setState({ isLoading: true, isTyping: false, isSuggested: false });
        FakeData.$("#root").scrollTop(0)
        const _that = this;

        const hasDate = aFilter.date.start === "" ? false : true;
        let date = "";
        if (hasDate) {
            const sArr = aFilter.date.start.split(" ");
            const eArr = aFilter.date.end.split(" ");
            date = sArr[0] + "/" + sArr[1] + "/" + sArr[2] + " to " + eArr[0] + "/" + eArr[1] + "/" + eArr[2]
        }

        const dataTo = {
            user: {
                id: FakeData.getData("yoo").id,
                type: "F"
            },
            search_data,
            date
        }

        //console.log(dataTo);
        FakeData.post("/search.php?auth0", dataTo, {
            success(res) {
                if (!FakeData.isMounted("search")) {
                    return
                }
                const all = [];
                for (const key in res) {
                    if (key === "search_data" || key === "All") {
                        continue;
                    }
                    if (res.hasOwnProperty(key)) {
                        const element = res[key];
                        FakeData.listify(element).forEach((item, i) => {
                            item.objectType = key;
                            all.push(item)
                        })
                    }
                }

                res.All = all;
                _that.setState({ results: res, isLoading: false });
                FakeData.$("#root").scrollTop(0)
            },
            error(err) {
                FakeData.alert("No results were found!")
                _that.setState({ isLoading: false });
            }
        }, true, "", (r) => { })
    }

    getFilteredSearchList = () => {
        const { search_data } = this.state.results;
        const { searches } = this.state;
        if (search_data.query === "") {
            return [];
        }

        const list = searches.filter((item) => {
            return item.query.toLowerCase().indexOf(search_data.query.toLowerCase()) > -1;
        })

        return list;
    }

    setObject = (obj) => {
        this.setState({ obj });
    }

    parseSaved = (data) => {
        const { search_data } = this.state.results;
        const all = [];
        const _that = this;
        const _data = data;
        if (data === null) {
            this.search();
            return;
        }
        for (const key in data) {
            if (key === "search_data" || key === "All") {
                continue;
            }
            if (data.hasOwnProperty(key)) {
                const element = data[key];
                FakeData.listify(element).forEach((item, i) => {
                    item.objectType = key;
                    all.push(item)
                })
            }
        }

        _data["All"] = all;
        this.setState({ results: _data, isLoading: false, isTyping: false, isSuggested: false });
        //this.setState({ isLoading: false, isTyping: false, isSuggested: false });
        FakeData.$("#root").scrollTop(0)

        const dataTo = {
            user: {
                id: FakeData.getData("yoo").id,
                type: "F"
            },
            search_data
        }

        //console.log(dataTo);
        setTimeout(() => {
            FakeData.post("/search.php?auth0", dataTo, {
                success(res) {
                    if (!FakeData.isMounted("search")) {
                        return
                    }
                    const all = [];
                    for (const key in res) {
                        if (key === "search_data" || key === "All") {
                            continue;
                        }
                        if (res.hasOwnProperty(key)) {
                            const element = res[key];
                            FakeData.listify(element).forEach((item, i) => {
                                item.objectType = key;
                                all.push(item)
                            })
                        }
                    }

                    res.All = all;
                    _that.setState({ results: res, isLoading: false });
                    FakeData.$("#root").scrollTop(0)
                },
                error(err) {
                    FakeData.alert("No results were found!")
                    _that.setState({ isLoading: false });
                }
            }, true, "", (r) => { })
        }, 1500)
    }

    setQuery = () => {
        const { results, aFilter } = this.state;
        const list = [];
        for (const key in aFilter) {
            if (aFilter.hasOwnProperty(key)) {
                if (key === "date") {
                    continue;
                }
                const element = aFilter[key];
                list.push(element)
            }
        }

        const str = list.join(" ");
        results.search_data.query = str === " " ? results.search_data.query : str;
        this.setState({ results, isSetting: false });
        this.search()
    }

    getMonths = () => {
        const { results } = this.state;
        const list = [];
        results.Games.forEach((item, i) => {
            if (!FakeData.inArray(item.date_month_tag, list)) {
                list.push(item.date_month_tag);
            }
        })

        return list;
    }

    getGamesForMonth = (month) => {
        const { results } = this.state;
        const list = results.Games.filter((item) => {
            return item.date_month_tag === month;
        })

        return list;
    }

    getEventMonths = () => {
        const { results } = this.state;
        const list = [];
        results.Events.forEach((item, i) => {
            if (!FakeData.inArray(item.date_month_tag, list)) {
                list.push(item.date_month_tag);
            }
        })

        return list;
    }

    getEventsForMonth = (month) => {
        const { results } = this.state;
        const list = results.Events.filter((item) => {
            return item.date_month_tag === month;
        })

        return list;
    }

    render = () => {
        const { filter, filters, results, isLoading, offset, isTyping, searches, isSuggested, isSetting, obj, aFilter, activeItem } = this.state;
        const hasDate = aFilter.date.start === "" ? false : true;
        let date = "";
        if (hasDate) {
            const sArr = aFilter.date.start.split(" ");
            const eArr = aFilter.date.end.split(" ");
            date = sArr[0] + "/" + sArr[1] + "/" + sArr[2] + " to " + eArr[0] + "/" + eArr[1] + "/" + eArr[2]
        }

        return (
            <div className="search-page" tabIndex={0} onFocus={() => {
                //this.setState({ isTyping: false, isSuggested: false });
            }} >
                <Helmet
                    title={"Search " + results.search_data.query}
                    meta={[
                        { "name": "description", "content": "Search Supotsu" },
                        { property: "og:type", content: "search" },
                        { property: "og:title", content: "Search " + results.search_data.query },
                        { property: "og:image", content: "" },
                        { property: "og:url", content: FakeData.baseURL + "/search" }
                    ]}
                />
                <div className="search-page-filters" style={{ marginTop: offset <= 8 ? "182px" : "120px" }}>
                    {
                        filters.map((item, i) => {
                            return (
                                <div className={filter === item ? "active" : ""} key={item} onClick={() => {
                                    this.setState({ filter: item })
                                    FakeData.$("#root").scrollTop(0)
                                }}>{item}</div>
                            )
                        })
                    }
                </div>
                <div className="search-page-input" style={{ marginTop: offset <= 8 ? "60px" : "20px", paddingBottom: offset <= 8 ? "30px" : "10px", paddingTop: offset <= 8 ? "60px" : "50px" }}>
                    {offset <= 9 && <h1>What are you looking for?</h1>}
                    <div className="search-page-input-bg" />
                    <div className="search-page-input-suggest-holder" tabIndex={0} onFocus={() => {
                        this.setState({ isSuggested: true });
                    }} onBlur={() => {
                        this.setState({ isSuggested: false });
                    }} >
                        {(this.getFilteredSearchList().length > 0 && (isTyping || isSuggested)) &&
                            <div className="search-page-input-suggest">
                                {
                                    this.getFilteredSearchList().map((item, i) => {
                                        return (
                                            <div className="search-page-input-suggest-item" key={i} onMouseEnter={() => {
                                                this.setState({ isSuggested: true, isTyping: true });
                                            }}>
                                                <span onClick={() => {
                                                    results.search_data.query = item.query;
                                                    this.setState({ results, isTyping: false, isSuggested: false });
                                                    this.parseSaved(item.data);
                                                }}>{item.query}</span>
                                                <i className={"material-icons"}>close</i>
                                            </div>
                                        )
                                    })
                                }
                            </div>
                        }
                    </div>
                    <input type="search" value={results.search_data.query} placeholder="Search..." onChange={(e) => {
                        const val = e.target.value;
                        results.search_data.query = val;
                        this.setState({ results });
                    }} onKeyUp={(e) => {
                        if ((e.keyCode === 13 || e.which === 13)) {
                            this.search()
                        }
                    }} onFocus={() => {
                        this.setState({ isTyping: true });
                    }} onBlur={() => {
                        this.setState({ isTyping: false });
                    }} />
                    <i className="material-icons" onClick={this.search.bind(this)}>search</i>
                    <div className={isSetting ? "search-page-input-settings active" : "search-page-input-settings"} tabIndex={0} onFocus={() => {
                        this.setState({ isSetting: true });
                    }} onBlur={() => {
                        //this.setState({ isSetting: false });
                    }}>
                        {!isSetting && <i className="material-icons" onClick={() => this.setState({ isSetting: true })}>settings</i>}
                        {isSetting && <i className="material-icons" onClick={() => this.setState({ isSetting: false })}>close</i>}
                        {isSetting &&
                            <div className="search-page-input-settings-ctx" ref={"settingsCtx"} tabIndex={0}>
                                <span className="search-page-input-settings-ctx-hd">Search Settings</span>
                                <div className="search-page-input-settings-ctx-bdy">
                                    <SearchConfigField label="All these words" desc="Type all key words to search for" example="soccer chelsea">
                                        <input value={aFilter.all} onChange={(e) => {
                                            const val = e.target.value;
                                            aFilter.all = val;
                                            this.setState({ aFilter });
                                        }} />
                                    </SearchConfigField>

                                    <SearchConfigField label="Exact words or phrase" desc="Put exact words in quotes" example={"\"rugby game\""}>
                                        <input value={aFilter.exact} onChange={(e) => {
                                            const val = e.target.value;
                                            aFilter.exact = val;
                                            this.setState({ aFilter });
                                        }} />
                                    </SearchConfigField>

                                    <SearchConfigField label="Any of these words" desc="Type OR between all the words you want" example="soccer OR rubgy or cricket">
                                        <input value={aFilter.any} onChange={(e) => {
                                            const val = e.target.value;
                                            aFilter.any = val;
                                            this.setState({ aFilter });
                                        }} />
                                    </SearchConfigField>

                                    <SearchConfigField label="None of these words" desc="Put a minus sign just before words that you don't want" example={"-Tennis, -\"Real Madrid\""}>
                                        <input value={aFilter.none} onChange={(e) => {
                                            const val = e.target.value;
                                            aFilter.none = val;
                                            this.setState({ aFilter });
                                        }} />
                                    </SearchConfigField>

                                    <SearchConfigField label="Date range" desc="select date range of the results your're looking for" example={false}>
                                        <span>
                                            {date}
                                        </span>
                                        <EvtFilterCal parent={this.refs.settingsCtx} onDatePicked={(s, e) => {
                                            aFilter.date.end = e;
                                            aFilter.date.start = s;
                                            this.setState({ aFilter });
                                        }} />
                                    </SearchConfigField>

                                    <button onClick={this.setQuery.bind(this)}>Search</button>
                                </div>
                            </div>
                        }
                    </div>
                </div>
                <InfiniteScrollView onScrollCallBack={(e) => {
                    this.setState({ offset: e.target.scrollTop });
                }} onScrollEndCallBack={(e) => {

                }} >
                    <div className="search-page-content" style={{ marginTop: offset <= 10 ? "162px" : "100px" }}>
                        <div className="search-page-content-filters">
                            <ViewObject type={obj !== null ? obj.objectType : filter !== "All" ? filter : (results.All.length > 0) ? results.All[0].objectType : null} content={obj !== null ? obj : (results[filter].length > 0) ? results[filter][0] : null} render={obj !== null ? true : (filter !== "All" && results[filter].length > 0) ? true : results[filter].length > 0 ? true : false} />
                            <WeatherWidget />
                        </div>
                        {isLoading &&
                            <div className="search-page-content-body">
                                <LoadingState isShown={isLoading} text={"Searching..."} />
                            </div>
                        }
                        {((filter === "All" && results.Posts.length === 0 && results.People.length === 0 && results.Clubs.length === 0 && results.Media.length === 0 && results.Games.length === 0 && results.Teams.length === 0 && results.Institutions.length === 0 && results.Tournaments.length === 0 && results.Groups.length === 0 && results.Events.length === 0) && !isLoading) &&
                            <div className="search-page-content-body">
                                <EmptyState style={{ background: "#fff" }} isShown={true} text="No results were found!" icon="landscape" />
                            </div>
                        }
                        {((filter !== "All" && results[filter].length === 0) && !isLoading) &&
                            <div className="search-page-content-body">
                                <EmptyState style={{ background: "#fff" }} isShown={true} text="No results were found!" icon="landscape" />
                            </div>
                        }
                        {(((filter === "All" && results.All.length > 0) || (filter !== "All" && results[filter].length > 0)) && !isLoading) &&
                            <div className="search-page-content-body">
                                <SearchCard shown={((filter === "All" || filter === "Posts") && (FakeData.listify(results.Posts).filter((item,i)=>{
                                    const block = FakeData.getBlocked({props:{}}, false, ["post"]);
                                    return !FakeData.inArray(item.id, block)
                                }).length > 0)) ? true : false} icon="picture_in_picture" iconStyle={{ background: "#D21E41" }} label="Posts" headTxt="See All" footTxt="See All" showFoot={filter === "All" ? true : false} showHead={false} onFootClick={(tab) => this.setState({ filter: tab })}>
                                    {
                                        FakeData.listify(results.Posts).map((item, i) => {
                                            if (filter === "All" && i >= 3) {
                                                return null;
                                            }
                                            const block = FakeData.getBlocked({props:{}}, false, ["post"]);
                                            if(FakeData.inArray(item.id, block)){
                                                return null;
                                            }
                                            return (
                                                <SearchPostItem post={item} query={results.search_data.queries} key={i} />
                                            )
                                        })
                                    }
                                </SearchCard>

                                <SearchCard shown={((filter === "All" || filter === "People") && (FakeData.listify(results.People).filter((item,i)=>{
                                    const block = FakeData.getBlocked({props:{}}, false, ["F"]);
                                    return !FakeData.inArray(item.id, block)
                                }).length > 0)) ? true : false} icon="person" iconStyle={{ background: "#4A5462" }} label="People" headTxt="See All" footTxt="See All" showFoot={filter === "All" ? true : false} showHead={false} onFootClick={(tab) => this.setState({ filter: tab })}>
                                    {
                                        FakeData.listify(results.People).map((item, i) => {
                                            if (filter === "All" && i >= 3) {
                                                return null;
                                            }
                                            const block = FakeData.getBlocked({props:{}}, false, ["F"]);
                                            if(FakeData.inArray(item.id, block)){
                                                return null;
                                            }
                                            return (
                                                <PeopleItem item={item} query={results.search_data.queries} key={i} onClick={() => this.setObject(item)} />
                                            )
                                        })
                                    }
                                </SearchCard>

                                <SearchCard shown={((filter === "All" || filter === "Media") && (FakeData.listify(results.Media).length > 0)) ? true : false} icon="camera_roll" iconStyle={{ background: "#AA00FF" }} label="Media" headTxt="See All" footTxt="See All" showFoot={filter === "All" ? true : false} showHead={false} onFootClick={(tab) => this.setState({ filter: tab })}>
                                    <SearchMediaList media={FakeData.listify(results.Media)} query={results.search_data.queries} filter={filter} onClick={(a) => {
                                        this.setState({ activeItem: a });
                                    }} />
                                </SearchCard>

                                <SearchCard shown={((filter === "All" || filter === "Games") && (FakeData.listify(results.Games).length > 0)) ? true : false} icon="/images/who_sees_game.svg" iconStyle={{ background: "" }} isImage={true} label="Games" headTxt="Select date range" footTxt="See All" showFoot={filter === "All" ? true : false} showHead={true} onHeadClick={() => this.setState({ isSetting: true })} onFootClick={(tab) => this.setState({ filter: tab })}>
                                    {
                                        this.getMonths().map((item, i) => {
                                            if (filter === "All" && i >= 3) {
                                                return null;
                                            }
                                            return (
                                                <UpcomingGameList embed={false} filterable={false} filter={"All"} style={{ margin: "0px 0px" }} key={i} item={item} games={this.getGamesForMonth(item)} />
                                            )
                                            {/*return (
                                                <Link to={{ pathname: "/game/" + item.id, search: "" }} className="search-game-item" key={i} onClick={() => this.setObject(item)} >
                                                    <img src={item.teamOne.image} />
                                                    <div className="search-game-item-info">
                                                        <span>{item.teamOne.squad.name != "" ? item.teamOne.squad.name : item.teamOne.name} vs {item.teamTwo.squad.name != "" ? item.teamTwo.squad.name : item.teamTwo.name}</span>
                                                        <span><strong>{item.datetime}</strong></span>
                                                        <span style={{ fontSize: "11px" }}>{item.ground !== "" ? item.ground + "" : ""}</span>
                                                    </div>
                                                    <img src={item.teamTwo.image} />
                                                </Link>
                                            )*/}
                                        })
                                    }
                                </SearchCard>

                                <SearchCard shown={((filter === "All" || filter === "Clubs") && (FakeData.listify(results.Clubs).filter((item,i)=>{
                                    const block = FakeData.getBlocked({props:{}}, false, ["C"]);
                                    return !FakeData.inArray(item.id, block)
                                }).length > 0)) ? true : false} icon="/images/club.svg" iconStyle={{ background: "#4ac" }} isImage={true} label="Clubs" headTxt="See All" footTxt="See All" showFoot={filter === "All" ? true : false} showHead={false} onFootClick={(tab) => this.setState({ filter: tab })}>
                                    {
                                        FakeData.listify(results.Clubs).map((item, i) => {
                                            if (filter === "All" && i >= 3) {
                                                return null;
                                            }
                                            const block = FakeData.getBlocked({props:{}}, false, ["C"]);
                                            if(FakeData.inArray(item.id, block)){
                                                return null;
                                            }
                                            return (
                                                <UniqItem item={item} query={results.search_data.queries} key={i} onClick={() => this.setObject(item)} />
                                            )
                                        })
                                    }
                                </SearchCard>

                                <SearchCard shown={((filter === "All" || filter === "Teams") && (FakeData.listify(results.Teams).filter((item,i)=>{
                                    const block = FakeData.getBlocked({props:{}}, false, ["T"]);
                                    return !FakeData.inArray(item.id, block)
                                }).length > 0)) ? true : false} icon="/images/who_sees_team.svg" iconStyle={{ background: "" }} isImage={true} label="Teams" headTxt="See All" footTxt="See All" showFoot={filter === "All" ? true : false} showHead={false} onFootClick={(tab) => this.setState({ filter: tab })}>
                                    {
                                        FakeData.listify(results.Teams).map((item, i) => {
                                            if (filter === "All" && i >= 3) {
                                                return null;
                                            }
                                            const block = FakeData.getBlocked({props:{}}, false, ["T"]);
                                            if(FakeData.inArray(item.id, block)){
                                                return null;
                                            }
                                            return (
                                                <UniqItem item={item} query={results.search_data.queries} key={i} onClick={() => this.setObject(item)} />
                                            )
                                        })
                                    }
                                </SearchCard>

                                <SearchCard shown={((filter === "All" || filter === "Institutions") && (FakeData.listify(results.Institutions).filter((item,i)=>{
                                    const block = FakeData.getBlocked({props:{}}, false, ["I"]);
                                    return !FakeData.inArray(item.id, block)
                                }).length > 0)) ? true : false} icon="school" iconStyle={{ background: "" }} label="Institutions" headTxt="See All" footTxt="See All" showFoot={filter === "All" ? true : false} showHead={false} onFootClick={(tab) => this.setState({ filter: tab })}>
                                    {
                                        FakeData.listify(results.Institutions).map((item, i) => {
                                            if (filter === "All" && i >= 3) {
                                                return null;
                                            }
                                            const block = FakeData.getBlocked({props:{}}, false, ["I"]);
                                            if(FakeData.inArray(item.id, block)){
                                                return null;
                                            }
                                            return (
                                                <UniqItem item={item} query={results.search_data.queries} key={i} onClick={() => this.setObject(item)} />
                                            )
                                        })
                                    }
                                </SearchCard>

                                <SearchCard shown={((filter === "All" || filter === "Tournaments") && (FakeData.listify(results.Tournaments).filter((item,i)=>{
                                    const block = FakeData.getBlocked({props:{}}, false, ["L"]);
                                    return !FakeData.inArray(item.id, block)
                                }).length > 0)) ? true : false} icon="/images/who_sees_league.svg" iconStyle={{ background: "" }} isImage={true} label="Tournaments" headTxt="See All" footTxt="See All" showFoot={filter === "All" ? true : false} showHead={false} onFootClick={(tab) => this.setState({ filter: tab })}>
                                    {
                                        FakeData.listify(results.Tournaments).map((item, i) => {
                                            if (filter === "All" && i >= 3) {
                                                return null;
                                            }
                                            const block = FakeData.getBlocked({props:{}}, false, ["L"]);
                                            if(FakeData.inArray(item.id, block)){
                                                return null;
                                            }
                                            return (
                                                <UniqItem item={item} query={results.search_data.queries} key={i} onClick={() => this.setObject(item)} />
                                            )
                                        })
                                    }
                                </SearchCard>

                                <SearchCard shown={((filter === "All" || filter === "Groups") && (FakeData.listify(results.Groups).filter((item,i)=>{
                                    const block = FakeData.getBlocked({props:{}}, false, ["Q"]);
                                    return !FakeData.inArray(item.id, block)
                                }).length > 0)) ? true : false} icon="group" iconStyle={{ background: "teal" }} label="Groups" headTxt="See All" footTxt="See All" showFoot={filter === "All" ? true : false} showHead={false} onFootClick={(tab) => this.setState({ filter: tab })}>
                                    {
                                        FakeData.listify(results.Groups).map((item, i) => {
                                            if (filter === "All" && i >= 3) {
                                                return null;
                                            }
                                            const block = FakeData.getBlocked({props:{}}, false, ["Q"]);
                                            if(FakeData.inArray(item.id, block)){
                                                return null;
                                            }
                                            return (
                                                <GroupItem item={item} query={results.search_data.queries} key={i} onClick={() => this.setObject(item)} />
                                            )
                                        })
                                    }
                                </SearchCard>

                                <SearchCard shown={((filter === "All" || filter === "Events") && (FakeData.listify(results.Events).length > 0)) ? true : false} icon="event" iconStyle={{ background: "#29b" }} label="Events" headTxt="Select date range" footTxt="See All" showFoot={filter === "All" ? true : false} showHead={true} onHeadClick={() => this.setState({ isSetting: true })} onFootClick={(tab) => this.setState({ filter: tab })}>
                                    {
                                        this.getEventMonths().map((item, i) => {
                                            if (filter === "All" && i >= 3) {
                                                return null;
                                            }
                                            return (
                                                <UpcomingGameList embed={true} filterable={false} filter={"All"} style={{ margin: "0px 0px" }} key={i} item={item} games={[]}>
                                                    {
                                                        this.getEventsForMonth(item).map((_item, _i) => {
                                                            if (filter === "All" && _i >= 3) {
                                                                return null;
                                                            }
                                                            return (
                                                                <EventItem item={_item} query={results.search_data.queries} key={_i} onClick={() => this.setObject(_item)} />
                                                            )
                                                        })
                                                    }
                                                </UpcomingGameList>
                                            )
                                        })
                                    }
                                </SearchCard>
                            </div>
                        }
                    </div>
                </InfiniteScrollView>
                {activeItem !== null &&
                    <FilePostViewer user={FakeData.getData("yoo")} userType={"F"} pos={0} post={activeItem} isOpen={activeItem === null ? false : true} onClose={() => {
                        this.setState({
                            activeItem: null
                        });
                    }} />
                }
            </div>
        )
    }
}

const SearchCard = (props) => {
    const { iconStyle, shown, onFootClick, onHeadClick } = props;
    if (!shown) {
        return null;
    }
    return (
        <div className="search-card">
            <div className="search-card-head">
                <div>
                    {!props.isImage && <i className="material-icons" style={{ ...iconStyle }}>{props.icon}</i>}
                    {props.isImage && <img src={props.icon} style={{ ...iconStyle }} />}
                    <span>{props.label}</span>
                </div>
                {(props.showHead) && <span onClick={onHeadClick}>{props.headTxt}</span>}
            </div>
            <div className="search-card-body">
                {props.children}
            </div>
            {props.showFoot && <div className="search-card-foot" onClick={() => {
                onFootClick(props.label)
                FakeData.$("#root").scrollTop(0)
            }}>{props.footTxt}</div>}
        </div>
    )
}

class PeopleItem extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isActed: this.props.item.isPending,
            isFriends: this.props.item.isFriends,
        }
    }

    render = () => {
        const { item } = this.props;
        const { isActed, isFriends } = this.state;
        return (
            <div className="results-people-item" key={item.id}>
                <img src={item.image} alt={""} onClick={this.props.onClick} />
                <div className="results-people-item-ctx" onClick={this.props.onClick}>
                    <span><strong>{item.name}</strong></span>
                    <span>@{item.user}</span>
                </div>
                {(!isFriends && !isActed && !item.isApproval && FakeData.getData("yoo").id !== item.id) &&
                    <div className="results-people-item-action">
                        <i className="material-icons">person_add</i>
                        <span>Add Friend</span>
                    </div>
                }
                {(!isFriends && item.isPending && !item.isApproval && FakeData.getData("yoo").id !== item.id) &&
                    <div className="results-people-item-action" style={{ background: "#ccc", border: "0.3px solid #888", color: "#777" }}>
                        <i className="material-icons">close</i>
                        <span>Request Sent</span>
                    </div>
                }
                {(isFriends && !item.isPending && !item.isApproval && FakeData.getData("yoo").id !== item.id) &&
                    <div className="results-people-item-action" style={{ background: "#ccc", border: "0.3px solid #888", color: "#777" }}>
                        <i className="material-icons">done</i>
                        <span>Friends</span>
                    </div>
                }
                {item.isYou &&
                    <div className="results-people-item-action" style={{ background: "#ccc", border: "0.3px solid #888", color: "#777" }}>
                        <i className="material-icons">person</i>
                        <span>You</span>
                    </div>
                }
            </div>
        )
    }

}

class SearchPostItem extends Component {
    constructor(props) {
        super(props);

    }

    highlight = (text = "", array = []) => {
        const stringArray = text.split(" ");
        const list = [];
        const array2 = array.forEach((item) => {
            FakeData.nullify(item).toLowerCase()
        })
        stringArray.forEach((item) => {
            if (array.join(" ").toLowerCase().indexOf(FakeData.nullify(item).toLowerCase()) > -1) {
                item = '<strong>' + item + '</strong>';
            }

            list.push(item)
        })

        return list.join(" ");
    }

    render = () => {
        const { post, query } = this.props;
        return (
            <Link to={{ pathname: "/post/" + post.user.user + "/posts/" + post.id + "/post?sComment=null&sReply=null" }} className="search-post-item">
                <div className="search-post-item-head">
                    <img src={post.user.image} />
                    <div>
                        <span><strong>{post.user.name}</strong></span>
                        <span>{FakeData.moment(post.timeAgo).fromNow()}</span>
                    </div>
                </div>
                <div className="search-post-item-body">
                    <div className="search-post-item-body-ctx">
                        <span dangerouslySetInnerHTML={{ __html: this.highlight(post.content, FakeData.listify(query)) }}></span>
                        <div className="search-post-item-foot">
                            <span>{post.likes.length === 0 ? null : FakeData.shortDigit(post.likes.length, "Like").data}</span>
                            <span>{post.comments.length === 0 ? null : FakeData.shortDigit(post.comments.length, "Comment").data}</span>
                        </div>
                    </div>
                    {post.media.length > 0 &&
                        <div className="search-post-item-body-media">
                            <img src={post.media[0].url} />
                            {post.media.length > 0 &&
                                <div>{"+" + (post.media.length + 1)}</div>
                            }
                        </div>
                    }
                </div>
            </Link>
        )
    }
}

class SearchMediaList extends Component {
    constructor(props) {
        super(props);
        this.state = {
            activeItem: null
        }
    }

    getDummy = (_num) => {
        const list = [];
        for (var index = 0; index < _num; index++) {
            list.push({ text: index })
        }

        return list;
    }

    render = () => {
        const { media, filter } = this.props;
        const { activeItem } = this.state;
        let rem = FakeData.listify(media).length % 4;
        rem = rem === 1 ? 3 : rem === 3 ? 1 : rem;
        return (
            <div className="search-media-list">
                {
                    FakeData.listify(media).map((item, i) => {
                        if (filter === "All" && i > 3) {
                            return null;
                        }
                        return (
                            <div key={i}>
                                <MediaItem file={item.media[0]} key={i} onMediaClick={(d) => this.props.onClick(item)} />
                            </div>
                        )
                    })
                }
                {(filter === "All" && FakeData.listify(media).length < 4) &&
                    this.getDummy(rem).map((item, i) => {
                        return (
                            <div key={i}>

                            </div>
                        )
                    })
                }

                {(filter === "Media") &&
                    this.getDummy(rem).map((item, i) => {
                        return (
                            <div key={i}>

                            </div>
                        )
                    })
                }


            </div>
        )
    }
}

class UniqItem extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isActed: this.props.item.isLiked
        }
    }

    like() {
        const { item } = this.props;
        const dataTo = {
            user: FakeData.getData("yoo"),
            type: item.type,
            contentId: item.id,
            userOne: item,
            userTwo: null,
            users: item.roles,
            userType: "F"
        }

        const _that = this

        FakeData.post('/likeContent.php?auth0', dataTo, {
            success: ((res) => {
                FakeData.alert("Done!");
                _that.setState({ isActed: true });
            }),
            error: ((err) => {

            })
        }, true, "", () => { })
    }

    render = () => {
        const { item } = this.props;
        const { isActed } = this.state;
        return (
            <div className="results-people-item" key={item.id}>
                <img src={item.image} alt={""} style={{ borderRadius: "0px" }} onClick={this.props.onClick} />
                <div className="results-people-item-ctx" onClick={this.props.onClick}>
                    <span><strong>{item.name}</strong></span>
                    <span>{item.likes.length === 0 ? "Be the first person to like this page" : FakeData.shortDigit(item.likes.length, "Like").data}</span>
                </div>
                {(!isActed) &&
                    <div className="results-people-item-action" onClick={this.like.bind(this)}>
                        <i className="material-icons">thumb_up</i>
                        <span>Like</span>
                    </div>
                }
                {(isActed) &&
                    <div className="results-people-item-action" style={{ background: "#ccc", border: "0.3px solid #888", color: "#777" }}>
                        <i className="material-icons">done</i>
                        <span>Liked</span>
                    </div>
                }
            </div>
        )
    }

}

class GroupItem extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isActed: this.props.item.isMember,
            isPending: this.props.item.isPending
        }
    }

    join = () => {
        const { item } = this.props;
        const _that = this;
        const users = FakeData.listify(item.members);

        const admins = FakeData.listify(item.members).filter((item) => {
            return item.role === "admin";
        });

        const data = {
            userId: FakeData.getData("yoo").id,
            userType: "F",
            users,
            admins,
            group: item
        }
        //joinGroup

        //console.log(data)
        FakeData.post("/joinGroup.php?auth0", data, {
            success(res) {
                if (res.error) {
                    FakeData.alert("Couldn't finish request! Try again later!")
                } else {
                    FakeData.alert("Done!")
                    _that.setState({ isPending: true });
                }
            },
            error(err) {
                FakeData.alert("Couldn't finish request! Try again later!")
            }
        }, true, "", (r) => { })
    }

    cancel = () => {
        const { item } = this.props
        const users = FakeData.listify(item.requests).filter((item) => {
            return item.id === FakeData.getData("yoo").id;
        });

        if (!item.isPending) {
            return;
        }

        const user = users[0];

        const _that = this;

        const data = {
            userId: user.id,
            userType: user.type,
            joinId: user.joinId,
            groupId: item.id,
        }

        //console.log(data)
        FakeData.post("/removeGroupForumRequest.php?auth0", data, {
            success(res) {
                if (res.error) {
                    FakeData.alert("Couldn't remove request! Try again later!")
                    _that.setState({ isPending: true });
                } else {
                    //FakeData.alert("Member was successfully removed from this group!")
                    _that.setState({ isPending: true });
                }
            },
            error(err) {
                FakeData.alert("Couldn't remove request! Try again later!")
                _that.setState({
                    isRemoving: false
                })
            }
        }, true, "", (r) => { })
    }

    render = () => {
        const { item } = this.props;
        const { isActed, isPending } = this.state;
        return (
            <div className="results-people-item" key={item.id}>
                <img src={item.image} alt={""} onClick={this.props.onClick} />
                <div className="results-people-item-ctx" onClick={this.props.onClick}>
                    <span><strong>{item.name}</strong></span>
                    <span>{item.users.length === 0 ? "Be the first person to join this group" : FakeData.shortDigit(item.users.length, "Member").data}</span>
                </div>
                {(!isActed && !isPending) &&
                    <div className="results-people-item-action" onClick={this.join.bind(this)}>
                        <i className="material-icons">person_add</i>
                        <span>Join Group</span>
                    </div>
                }
                {(!isActed && isPending) &&
                    <div className="results-people-item-action" style={{ background: "#ccc", border: "0.3px solid #888", color: "#777" }}>
                        <i className="material-icons">close</i>
                        <span>{"Request Sent"}</span>
                    </div>
                }
                {(isActed && !isPending) &&
                    <div className="results-people-item-action" style={{ background: "#ccc", border: "0.3px solid #888", color: "#777" }}>
                        <i className="material-icons">done</i>
                        <span>Joined</span>
                    </div>
                }
            </div>
        )
    }

}

class EventItem extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isActed: this.props.item.isGoing
        }
    }

    interested = () => {
        const { item } = this.props;
        const _that = this;
        const dataTo = {
            user: {
                id: FakeData.getData("yoo").id,
                type: "F"
            },
            userTo: item.created,
            eventId: item.id,
            isInterested: true
        }

        FakeData.post("/addToEvent.php?auth0", dataTo, {
            success(res) {
                FakeData.alert("Done!");
                _that.setState({ isActed: true });
            },
            error(err) {

            }
        }, true, "", (t) => { })
    }

    getYou = () => {
        const id = FakeData.getData("yoo").id;
        const { item } = this.props;
        const list = FakeData.listify(item.users).filter((_item) => {
            return _item.id === id;
        })

        if (list.length === 0) {
            return false;
        }

        return list[0];
    }

    render = () => {
        const { item } = this.props;
        const { isActed } = this.state;
        return (
            <div className="results-people-item" key={item.id}>
                <img src={item.image} alt={""} style={{ borderRadius: "0px" }} onClick={this.props.onClick} />
                <div className="results-people-item-ctx" onClick={this.props.onClick}>
                    <span><strong>{item.name}</strong></span>
                    <span className="event-item-label-sx"><i className="material-icons">my_location</i> {item.place}</span>
                    {item.isOneDay &&
                        <span className="event-item-label-sx"><i className="material-icons">event</i> {item.normalDate}</span>
                    }
                    {item.isOneDay &&
                        <span className="event-item-label-sx"><i className="material-icons">alarm</i>{item.startTime + " - " + item.endTime}</span>
                    }
                    {!item.isOneDay &&
                        <span className="event-item-label-sx"><i className="material-icons">event</i> {item.dateRange}</span>
                    }
                    {!item.isOneDay &&
                        <span className="event-item-label-sx"><i className="material-icons">alarm</i>{item.timeRange}</span>
                    }
                </div>
                {(!isActed) &&
                    <div className="results-people-item-action" onClick={this.interested.bind(this)}>
                        <i className="material-icons">add</i>
                        <span>Interested</span>
                    </div>
                }
                {(isActed) &&
                    <div className="results-people-item-action" style={{ background: "#ccc", border: "0.3px solid #888", color: "#777" }}>
                        <i className="material-icons">done</i>
                        <span>{!this.getYou() ? "Interested" : this.getYou().status === "yes" ? "Going" : this.getYou().status === "no" ? "Not Going" : this.getYou().status === "maybe" ? "Maybe Going" : this.getYou().status === "interested" ? "Interested" : "Going"}</span>
                    </div>
                }
            </div>
        )
    }

}

const SearchConfigField = (props) => {
    return (
        <div className="search-config-fld">
            <span>{props.label}</span>
            <div className="search-config-fld-textbox" tabIndex={0}>
                {props.children}
            </div>
            <div className="search-config-fld-details">
                <span>{props.example ? props.desc + " : " : props.desc}</span>
                {props.example && <code>{props.example}</code>}
            </div>
        </div>
    )
}

const ViewObject = (props) => {
    if (!props.render) {
        return null;
    }

    if (props.content === null) {
        return null;
    }

    if (props.content.objectType === "Posts" || props.content.objectType === "Games" || props.content.objectType === "Media") {
        return null;
    }

    return (
        <div style={{ width: "100%", height: "auto", background: "#fff", marginBottom: "0.5vw" }}>
            {props.type === "People" &&
                <UserKnowledgeGraph key={props.content.id} user={props.content} />
            }
            {props.type === "Teams" &&
                <TeamKnowledgeGraph key={props.content.id} team={props.content} />
            }
            {props.type === "Clubs" &&
                <ClubKnowledgeGraph key={props.content.id} club={props.content} />
            }
            {props.type === "Institutions" &&
                <InstitutionKnowledgeGraph key={props.content.id} club={props.content} />
            }
            {props.type === "Tournaments" &&
                <TournKnowledgeGraph key={props.content.id} tourn={props.content} />
            }
            {props.type === "Events" &&
                <EventKnowledgeGraph key={props.content.id} event={props.content} />
            }
            {props.type === "Groups" &&
                <GroupKnowledgeGraph key={props.content.id} group={props.content} />
            }
        </div>
    )
}

export class UserKnowledgeGraph extends Component {
    constructor(props) {
        super(props);
        this.state = {
            profile: { id: null },
            isLoading: true,
            error: false,
            color: "#fff",
            isShowingAbout: false
        }
    }

    componentDidMount = () => {
        FakeData.mountState("UserKnowledgeGraph", true);
        this.getProfile()
    }

    getProfile = () => {
        const _that = this

        FakeData.post("/getUserProfile.php?auth0&id=" + FakeData.getData('yoo').username + "&them=" + this.props.user.id, {}, {
            success: ((res) => {
                if (!FakeData.isMounted("UserKnowledgeGraph")) {
                    return
                }
                if (res.error) {
                    _that.setState({
                        error: true,
                        isLoading: false
                    });
                } else {
                    _that.setState({
                        profile: res,
                        error: false,
                        isLoading: false
                    });

                    //FakeData.setTitle((!res.name)?"Profile":res.name+"'s Profile")
                }
            }),
            error: ((err) => {

            })
        })
    }

    render = () => {
        const { isLoading, error, profile, color, isShowingAbout } = this.state;
        if (isLoading) {
            return (
                <LoadingState isShown={isLoading} text={"Loading"} />
            )
        }

        if (error) {
            return (
                <EmptyState isShown={error} icon="person" text={"Profile not found!"} />
            )
        }

        const theirSports = FakeData.listify(profile.mySport).length > 0 ? FakeData.listify(profile.mySport) : FakeData.listify(profile.sportsFollowed);
        const theirTeams = FakeData.listify(profile.myTeams).length > 0 ? FakeData.listify(profile.myTeams) : FakeData.listify(profile.teamsFollowed);
        const theirFriends = FakeData.listify(profile.friends);
        return (
            <div className="user-knowledge-graph">
                <div className="user-knowledge-graph-banner">
                    {profile.bg_image === FakeData.apiURL+"/" &&
                        <img className="user-knowledge-graph-banner-bg" />
                    }
                    {profile.bg_image !== FakeData.apiURL+"/" &&
                        <img src={profile.bg_image !== FakeData.apiURL+"/" ? profile.bg_image : ""} className="user-knowledge-graph-banner-bg" onLoad={(e) => {
                            try {
                                var vibrant = new window.Vibrant(e.target);
                                var swatches = vibrant.swatches();
                                const _that = this;
                                for (var swatch in swatches) {
                                    if (swatches.hasOwnProperty(swatch) && swatches[swatch] && swatch === "Vibrant") {
                                        //console.log(swatch, swatches[swatch].getHex(), swatches[swatch].getTitleTextColor())
                                        const color = swatches[swatch].getTitleTextColor();
                                        _that.setState({ color });
                                        break;
                                    }
                                }
                            } catch (error) {
                                
                            }
                        }} />
                    }
                    <img src={this.props.user.image} className="user-knowledge-graph-banner-pf" />
                    <div className="user-knowledge-graph-banner-ctx" style={{ color }}>
                        <span><strong>{this.props.user.name}</strong></span>
                        <span>@{this.props.user.user}</span>
                    </div>
                </div>
                {profile.about.length > 3 &&
                    <div className="user-knowledge-graph-bio">
                        <RichTextEditor content={profile.about.substring(0, 150)} isViewing={true} />
                        {isShowingAbout &&
                            <span></span>
                        }
                    </div>
                }

                {(profile.basicInfo[1].value !== "not set" && profile.basicInfo[1].value !== null) &&
                    <UserKnowledgeGraphLabel label={"Born"} style={{}}>
                        {profile.basicInfo[2].value + ", " + profile.basicInfo[1].value}
                    </UserKnowledgeGraphLabel>
                }
                {theirSports.length > 0 &&
                    <UserKnowledgeGraphLabel label={"Sports"} style={{ alignItems: "center" }}>
                        {
                            theirSports.map((item, i) => {
                                if (i > 3) {
                                    return null;
                                }
                                return (
                                    <div className="user-knowledge-team-item" key={i}>
                                        <img src={item.image.replace("_wht", "")} />
                                        <span>{item.name}</span>
                                    </div>
                                )
                            })
                        }
                    </UserKnowledgeGraphLabel>
                }

                {theirTeams.length > 0 &&
                    <UserKnowledgeGraphLabel label={"Teams"} style={{ alignItems: "center" }}>
                        {
                            theirTeams.map((item, i) => {
                                if (i > 3) {
                                    return null;
                                }

                                return (
                                    <div className="user-knowledge-team-item" key={i}>
                                        <img src={item.image} />
                                        <span>{item.name}</span>
                                    </div>
                                )
                            })
                        }
                    </UserKnowledgeGraphLabel>
                }

                {theirFriends.length > 0 &&
                    <UserKnowledgeGraphLabel label={"Friends"} style={{ alignItems: "center" }}>
                        {
                            theirFriends.map((item, i) => {
                                if (i > 3) {
                                    return null;
                                }

                                return (
                                    <div className="user-knowledge-team-item" key={i}>
                                        <img src={item.image} />
                                        <span>{item.name}</span>
                                    </div>
                                )
                            })
                        }
                    </UserKnowledgeGraphLabel>
                }
                <Link to={{ pathname: "/profile/" + this.props.user.user, search: "" }}>Visit Profile</Link>
            </div>
        )
    }
}

export class TeamKnowledgeGraph extends Component {
    constructor(props) {
        super(props);
        this.state = {
            profile: { id: null },
            isLoading: true,
            error: false,
            color: "#fff",
            isShowingAbout: false
        }
    }

    componentDidMount = () => {
        FakeData.mountState("TeamKnowledgeGraph", true);
        this.getProfile()
    }

    getProfile = () => {
        const _that = this
        const dataTo = {
            user: FakeData.getData('yoo'),
            teamId: this.props.team.id
        }

        FakeData.post("/getTeamProfile.php?auth0", dataTo, {
            success: ((res) => {
                if (!FakeData.isMounted("TeamKnowledgeGraph")) {
                    return
                }
                if (res.error) {
                    _that.setState({
                        error: true,
                        isLoading: false
                    });
                } else {
                    _that.setState({
                        profile: res,
                        error: false,
                        isLoading: false
                    });

                    //FakeData.setTitle((!res.name)?"Profile":res.name+"'s Profile")
                }
            }),
            error: ((err) => {

            })
        })
    }

    render = () => {
        const { isLoading, error, profile, color, isShowingAbout } = this.state;
        if (isLoading) {
            return (
                <LoadingState isShown={isLoading} text={"Loading"} />
            )
        }

        if (error) {
            return (
                <EmptyState isShown={error} icon="person" text={"Profile not found!"} />
            )
        }

        const theirTeams = FakeData.listify(profile.squads.current).length > 0 ? FakeData.listify((profile.squads.current)) : FakeData.listify((profile.squads.past));
        return (
            <div className="user-knowledge-graph">
                <div className="user-knowledge-graph-banner">
                    <img className="user-knowledge-graph-banner-bg" style={{ background: profile.bg_color }} />
                    <img src={this.props.team.image} className="user-knowledge-graph-banner-pf" onLoad={(e) => {
                        this.setState({ color: FakeData.getLuminance(profile.bg_color) });
                    }} style={{ borderRadius: 0 }} />
                    <div className="user-knowledge-graph-banner-ctx" style={{ color }}>
                        <span><strong>{this.props.team.name}</strong></span>
                        <span>{profile.ground}</span>
                    </div>
                </div>
                {profile.about.length > 3 &&
                    <div className="user-knowledge-graph-bio">
                        <RichTextEditor content={profile.about.substring(0, 150)} isViewing={true} />
                        {isShowingAbout &&
                            <span></span>
                        }
                    </div>
                }

                {(profile.establishYear !== null && profile.establishYear !== "") &&
                    <UserKnowledgeGraphLabel label={"Established"} style={{}}>
                        {profile.establishMonth + ", " + profile.establishYear}
                    </UserKnowledgeGraphLabel>
                }
                <UserKnowledgeGraphLabel label={"Sport"} style={{ alignItems: "center" }}>
                    <div className="user-knowledge-team-item" key={profile.sport.id}>
                        <img src={profile.sport.image.replace("_wht", "")} />
                        <span>{profile.sport.name}</span>
                    </div>
                </UserKnowledgeGraphLabel>
                {theirTeams.length > 0 &&
                    <UserKnowledgeGraphLabel label={"Squads"} style={{ alignItems: "center" }}>
                        {
                            theirTeams.map((item, i) => {
                                if (i > 3) {
                                    return null;
                                }

                                return (
                                    <div className="user-knowledge-team-item" key={i}>
                                        <img src={this.props.team.image} />
                                        <span>{item.name}</span>
                                    </div>
                                )
                            })
                        }
                    </UserKnowledgeGraphLabel>
                }
                <Link to={{ pathname: "/team/" + this.props.team.id, search: "" }}>Visit Profile</Link>
            </div>
        )
    }
}

export class ClubKnowledgeGraph extends Component {
    constructor(props) {
        super(props);
        this.state = {
            profile: { id: null },
            isLoading: true,
            error: false,
            color: "#fff",
            isShowingAbout: false
        }
    }

    componentDidMount = () => {
        FakeData.mountState("ClubKnowledgeGraph", true);
        this.getProfile()
    }

    getProfile = () => {
        const _that = this
        const dataTo = {
            user: FakeData.getData('yoo'),
            clubId: this.props.club.user
        }

        FakeData.post("/getClubProfile.php?auth0", dataTo, {
            success: ((res) => {
                if (!FakeData.isMounted("ClubKnowledgeGraph")) {
                    return
                }
                if (res.error) {
                    _that.setState({
                        error: true,
                        isLoading: false
                    });
                } else {
                    _that.setState({
                        profile: res,
                        error: false,
                        isLoading: false
                    });

                    //FakeData.setTitle((!res.name)?"Profile":res.name+"'s Profile")
                }
            }),
            error: ((err) => {

            })
        })
    }

    render = () => {
        const { isLoading, error, profile, color, isShowingAbout } = this.state;
        if (isLoading) {
            return (
                <LoadingState isShown={isLoading} text={"Loading"} />
            )
        }

        if (error) {
            return (
                <EmptyState isShown={error} icon="person" text={"Profile not found!"} />
            )
        }

        const theirSports = FakeData.listify(profile.sports)
        const theirTeams = FakeData.listify(profile.teams.current).length > 0 ? FakeData.listify((profile.teams.current)) : FakeData.listify((profile.teams.past));
        return (
            <div className="user-knowledge-graph">
                <div className="user-knowledge-graph-banner">
                    <img className="user-knowledge-graph-banner-bg" style={{ background: profile.bg_color }} />
                    <img src={this.props.club.image} className="user-knowledge-graph-banner-pf" onLoad={(e) => {
                        this.setState({ color: FakeData.getLuminance(profile.bg_color) });
                    }} style={{ borderRadius: 0 }} />
                    <div className="user-knowledge-graph-banner-ctx" style={{ color }}>
                        <span><strong>{this.props.club.name}</strong></span>
                        <span>{profile.ground}</span>
                    </div>
                </div>
                {profile.about.length > 3 &&
                    <div className="user-knowledge-graph-bio">
                        <RichTextEditor content={profile.about.substring(0, 150)} isViewing={true} />
                        {isShowingAbout &&
                            <span></span>
                        }
                    </div>
                }

                {(profile.establishYear !== null && profile.establishYear !== "") &&
                    <UserKnowledgeGraphLabel label={"Established"} style={{}}>
                        {profile.establishMonth + ", " + profile.establishYear}
                    </UserKnowledgeGraphLabel>
                }
                {theirSports.length > 0 &&
                    <UserKnowledgeGraphLabel label={"Sports"} style={{ alignItems: "center" }}>
                        {
                            theirSports.map((item, i) => {
                                if (i > 3) {
                                    return null;
                                }
                                return (
                                    <div className="user-knowledge-team-item" key={i}>
                                        <img src={item.image.replace("_wht", "")} />
                                        <span>{item.name}</span>
                                    </div>
                                )
                            })
                        }
                    </UserKnowledgeGraphLabel>
                }
                {theirTeams.length > 0 &&
                    <UserKnowledgeGraphLabel label={"Teams"} style={{ alignItems: "center" }}>
                        {
                            theirTeams.map((item, i) => {
                                if (i > 3) {
                                    return null;
                                }

                                return (
                                    <div className="user-knowledge-team-item" key={i}>
                                        <img src={this.props.club.image} />
                                        <span>{item.name}</span>
                                    </div>
                                )
                            })
                        }
                    </UserKnowledgeGraphLabel>
                }
                <Link to={{ pathname: "/club/" + this.props.club.user, search: "" }}>Visit Profile</Link>
            </div>
        )
    }
}

export class InstitutionKnowledgeGraph extends Component {
    constructor(props) {
        super(props);
        this.state = {
            profile: { id: null },
            isLoading: true,
            error: false,
            color: "#fff",
            isShowingAbout: false
        }
    }

    componentDidMount = () => {
        FakeData.mountState("InstitutionKnowledgeGraph", true);
        this.getProfile()
    }

    getProfile = () => {
        const _that = this
        const dataTo = {
            user: FakeData.getData('yoo'),
            InstitutionID: this.props.club.user
        }

        FakeData.post("/getInstitutionProfile.php?auth0", dataTo, {
            success: ((res) => {
                if (!FakeData.isMounted("InstitutionKnowledgeGraph")) {
                    return
                }
                if (res.error) {
                    _that.setState({
                        error: true,
                        isLoading: false
                    });
                } else {
                    _that.setState({
                        profile: res,
                        error: false,
                        isLoading: false
                    });

                    //FakeData.setTitle((!res.name)?"Profile":res.name+"'s Profile")
                }
            }),
            error: ((err) => {

            })
        })
    }

    render = () => {
        const { isLoading, error, profile, color, isShowingAbout } = this.state;
        if (isLoading) {
            return (
                <LoadingState isShown={isLoading} text={"Loading"} />
            )
        }

        if (error) {
            return (
                <EmptyState isShown={error} icon="person" text={"Profile not found!"} />
            )
        }

        const theirSports = FakeData.listify(profile.sports)
        const theirTeams = FakeData.listify(profile.teams.current).length > 0 ? FakeData.listify((profile.teams.current)) : FakeData.listify((profile.teams.past));
        return (
            <div className="user-knowledge-graph">
                <div className="user-knowledge-graph-banner">
                    <img className="user-knowledge-graph-banner-bg" style={{ background: profile.bg_color }} />
                    <img src={this.props.club.image} className="user-knowledge-graph-banner-pf" onLoad={(e) => {
                        this.setState({ color: FakeData.getLuminance(profile.bg_color) });
                    }} style={{ borderRadius: 0 }} />
                    <div className="user-knowledge-graph-banner-ctx" style={{ color }}>
                        <span><strong>{this.props.club.name}</strong></span>
                        <span>{profile.ground}</span>
                    </div>
                </div>
                {profile.about.length > 3 &&
                    <div className="user-knowledge-graph-bio">
                        <RichTextEditor content={profile.about.substring(0, 150)} isViewing={true} />
                        {isShowingAbout &&
                            <span></span>
                        }
                    </div>
                }

                {(profile.establishYear !== null && profile.establishYear !== "") &&
                    <UserKnowledgeGraphLabel label={"Established"} style={{}}>
                        {profile.establishMonth + ", " + profile.establishYear}
                    </UserKnowledgeGraphLabel>
                }
                {theirSports.length > 0 &&
                    <UserKnowledgeGraphLabel label={"Sports"} style={{ alignItems: "center" }}>
                        {
                            theirSports.map((item, i) => {
                                if (i > 3) {
                                    return null;
                                }
                                return (
                                    <div className="user-knowledge-team-item" key={i}>
                                        <img src={item.image.replace("_wht", "")} />
                                        <span>{item.name}</span>
                                    </div>
                                )
                            })
                        }
                    </UserKnowledgeGraphLabel>
                }
                {theirTeams.length > 0 &&
                    <UserKnowledgeGraphLabel label={"Teams"} style={{ alignItems: "center" }}>
                        {
                            theirTeams.map((item, i) => {
                                if (i > 3) {
                                    return null;
                                }

                                return (
                                    <div className="user-knowledge-team-item" key={i}>
                                        <img src={this.props.club.image} />
                                        <span>{item.name}</span>
                                    </div>
                                )
                            })
                        }
                    </UserKnowledgeGraphLabel>
                }
                <Link to={{ pathname: "/institution/" + this.props.club.user, search: "" }}>Visit Profile</Link>
            </div>
        )
    }
}

export class TournKnowledgeGraph extends Component {
    constructor(props) {
        super(props);
        this.state = {
            profile: { id: null },
            isLoading: true,
            error: false,
            color: "#fff",
            isShowingAbout: false
        }
    }

    componentDidMount = () => {
        FakeData.mountState("TournKnowledgeGraph", true);
        this.getProfile()
    }

    getProfile = () => {
        const _that = this
        const dataTo = {
            user: FakeData.getData('yoo'),
            leagueId: this.props.tourn.user
        }

        FakeData.post("/getLeagueTournProfile.php?auth0", dataTo, {
            success: ((res) => {
                if (!FakeData.isMounted("TournKnowledgeGraph")) {
                    return
                }
                if (res.error) {
                    _that.setState({
                        error: true,
                        isLoading: false
                    });
                } else {
                    _that.setState({
                        profile: res,
                        error: false,
                        isLoading: false
                    });

                    //FakeData.setTitle((!res.name)?"Profile":res.name+"'s Profile")
                }
            }),
            error: ((err) => {

            })
        })
    }

    render = () => {
        const { isLoading, error, profile, color, isShowingAbout } = this.state;
        if (isLoading) {
            return (
                <LoadingState isShown={isLoading} text={"Loading"} />
            )
        }

        if (error) {
            return (
                <EmptyState isShown={error} icon="person" text={"Profile not found!"} />
            )
        }

        const theirSports = FakeData.listify()
        const theirTeams = FakeData.listify(profile.teams.current).length > 0 ? FakeData.listify((profile.teams.current)) : FakeData.listify((profile.teams.past));
        return (
            <div className="user-knowledge-graph">
                <div className="user-knowledge-graph-banner">
                    <img className="user-knowledge-graph-banner-bg" style={{ background: profile.bg_color }} />
                    <img src={this.props.tourn.image} className="user-knowledge-graph-banner-pf" onLoad={(e) => {
                        this.setState({ color: FakeData.getLuminance(profile.bg_color) });
                    }} style={{ borderRadius: 0 }} />
                    <div className="user-knowledge-graph-banner-ctx" style={{ color }}>
                        <span><strong>{this.props.tourn.name}</strong></span>
                        <span>{profile.type.capitalize()}</span>
                    </div>
                </div>
                {profile.about.length > 3 &&
                    <div className="user-knowledge-graph-bio">
                        <RichTextEditor content={profile.about.substring(0, 150)} isViewing={true} />
                        {isShowingAbout &&
                            <span></span>
                        }
                    </div>
                }

                {(profile.establishYear !== null && profile.establishYear !== "") &&
                    <UserKnowledgeGraphLabel label={"Established"} style={{}}>
                        {profile.establishMonth + ", " + profile.establishYear}
                    </UserKnowledgeGraphLabel>
                }
                {theirSports.length > 0 &&
                    <UserKnowledgeGraphLabel label={"Sports"} style={{ alignItems: "center" }}>
                        {
                            theirSports.map((item, i) => {
                                if (i > 3) {
                                    return null;
                                }
                                return (
                                    <div className="user-knowledge-team-item" key={i}>
                                        <img src={item.image.replace("_wht", "")} />
                                        <span>{item.name}</span>
                                    </div>
                                )
                            })
                        }
                    </UserKnowledgeGraphLabel>
                }
                {theirTeams.length > 0 &&
                    <UserKnowledgeGraphLabel label={"Teams"} style={{ alignItems: "center" }}>
                        {
                            theirTeams.map((item, i) => {
                                if (i > 3) {
                                    return null;
                                }

                                return (
                                    <div className="user-knowledge-team-item" key={i}>
                                        <img src={item.image} />
                                        <span>{item.name}</span>
                                    </div>
                                )
                            })
                        }
                    </UserKnowledgeGraphLabel>
                }
                <Link to={{ pathname: "/tournament/" + this.props.tourn.user, search: "" }}>Visit Profile</Link>
            </div>
        )
    }
}

export class EventKnowledgeGraph extends Component {
    constructor(props) {
        super(props);
        this.state = {
            profile: { id: null },
            isLoading: true,
            error: false,
            color: "#fff",
            isShowingAbout: false
        }
    }

    componentDidMount = () => {
        FakeData.mountState("EventKnowledgeGraph", true);
        this.getProfile()
    }

    getProfile = () => {
        const _that = this
        const dataTo = {
            userId: FakeData.getData('yoo').id,
            userType: "F",
            id: this.props.event.id
        }

        FakeData.post("/getEvent.php?auth0", dataTo, {
            success: ((res) => {
                if (!FakeData.isMounted("EventKnowledgeGraph")) {
                    return
                }
                if (res.error) {
                    _that.setState({
                        error: true,
                        isLoading: false
                    });
                } else {
                    _that.setState({
                        profile: res,
                        error: false,
                        isLoading: false
                    });

                    //FakeData.setTitle((!res.name)?"Profile":res.name+"'s Profile")
                }
            }),
            error: ((err) => {

            })
        })
    }

    render = () => {
        const { isLoading, error, profile, color, isShowingAbout } = this.state;
        if (isLoading) {
            return (
                <LoadingState isShown={isLoading} text={"Loading"} />
            )
        }

        if (error) {
            return (
                <EmptyState isShown={error} icon="person" text={"Profile not found!"} />
            )
        }

        return (
            <div className="user-knowledge-graph">
                <EventKnowledgeCard event={profile} hasBackLink={false} style={{ width: "100%", minHeight: "100px" }} h3style={{ margin: 0 }} />
                <Link to={{ pathname: "/event/" + profile.id, search: "" }}>Visit Profile</Link>
            </div>
        )
    }
}

export const UserKnowledgeGraphLabel = (props) => {
    const { style } = props
    return (
        <div className="user-knowledge-graph-label" style={{ ...style }}>
            <span>{props.label}</span>
            <span>:</span>
            <div className="user-knowledge-graph-label-ctx">
                {props.children}
            </div>
        </div>
    )
}

export class GroupKnowledgeGraph extends Component {
    constructor(props) {
        super(props);
        this.state = {
            profile: { id: null },
            isLoading: true,
            error: false,
            color: "#fff",
            isShowingAbout: false
        }
    }

    componentDidMount = () => {
        FakeData.mountState("GroupKnowledgeGraph", true);
        this.getProfile()
    }

    getProfile = () => {
        const _that = this
        const dataTo = {
            userId: FakeData.getData('yoo').id,
            groupId: this.props.group.user
        }

        FakeData.post("/getGroupForum.php?auth0", dataTo, {
            success: ((res) => {
                if (!FakeData.isMounted("GroupKnowledgeGraph")) {
                    return
                }
                if (res.error) {
                    _that.setState({
                        error: true,
                        isLoading: false
                    });
                } else {
                    _that.setState({
                        profile: res,
                        error: false,
                        isLoading: false
                    });

                    //FakeData.setTitle((!res.name)?"Profile":res.name+"'s Profile")
                }
            }),
            error: ((err) => {

            })
        })
    }

    render = () => {
        const { isLoading, error, profile, color, isShowingAbout } = this.state;
        if (isLoading) {
            return (
                <LoadingState isShown={isLoading} text={"Loading"} />
            )
        }

        if (error) {
            return (
                <EmptyState isShown={error} icon="person" text={"Profile not found!"} />
            )
        }

        return (
            <div className="user-knowledge-graph">
                <div className="user-knowledge-graph-banner">
                    <img className="user-knowledge-graph-banner-bg" style={{ background: "#374353" }} />
                    <img src={this.props.group.image} className="user-knowledge-graph-banner-pf" onLoad={(e) => {
                        this.setState({ color: FakeData.getLuminance("#374353") });
                    }} style={{ borderRadius: 0 }} />
                    <div className="user-knowledge-graph-banner-ctx" style={{ color }}>
                        <span><strong>{this.props.group.name}</strong></span>
                        <span>{profile.privacy}</span>
                    </div>
                </div>
                {this.is && <div className="group-side-view-header-2" style={{ borderBottom: "0.3px solid #eee", padding: "10px 15%" }}>
                    <div>
                        <span>Posts</span>
                        <span>0</span>
                    </div>
                    <div>
                        <span>Members</span>
                        <span>{FakeData.shortDigit(profile.members.length, "").text}</span>
                    </div>
                    <div>
                        <span>Media</span>
                        <span>0</span>
                    </div>
                </div>}
                {profile.about.length > 3 &&
                    <div className="user-knowledge-graph-bio" style={{ marginBottom: "5px" }} dangerouslySetInnerHTML={{ __html: profile.about.replace(/\r?\n/g, '<br/>').substring(0, 150) }}>

                    </div>
                }
                <UserKnowledgeGraphLabel label={"Members"} style={{ alignItems: "center" }}>
                    {
                        profile.members.map((item, i) => {
                            if (i > 3) {
                                return null;
                            }

                            return (
                                <div className="user-knowledge-team-item" key={i}>
                                    <img src={item.image} />
                                    <span>{item.name}</span>
                                </div>
                            )
                        })
                    }
                </UserKnowledgeGraphLabel>
                <Link to={{ pathname: "/group/" + this.props.group.user, search: "" }}>Visit Profile</Link>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/pages/Search.jsx